import { FC, useContext } from 'react'
import { Channel } from './Channel'
import { InternalContext } from '../contexts/InternalContext'
import './Channels.scss'
import { ChannelsSelection } from './ChannelsSelection'
import { useChannelsMousePositioning } from './hooks/useChannelsMousePositioning'
import { useChannelsMouseSelecting } from './hooks/useChannelsMouseSelecting'
import { ChannelsEditableSelection } from './ChannelsEditableSelection'
import { useChannelsPositionScrolling } from './hooks/useChannelsPositionScrolling'
import { useChannels } from './hooks/useChannels'
import { MousePosition } from '../components/MousePosition'
import { ChannelsLine } from './ChannelsLine'
import { PlaybackPosition } from '../components/PlaybackPosition'
import { ChannelsShiftSelection } from './ChannelsShiftSelection'
import { useShiftDown } from '../../hooks/useShiftDown'
import { useObservableRef } from '../../hooks/useObservableRef'
import { ChannelsRewind } from './ChannelsRewind'

export const Channels: FC = () => {
  const {
    setContainerElement,
    setBackgroundElement,
    mouseSelection,
    internalSelection,
    playbackCursorPosition,
    mousePosition,
    audioPlayer: { playback },
  } = useContext(InternalContext)
  const channels = useChannels()
  const shiftDown = useShiftDown()
  const mousePositionRef = useObservableRef(mousePosition)

  useChannelsMouseSelecting()
  useChannelsMousePositioning()
  useChannelsPositionScrolling()

  return (
    <div className="Channels">
      <div className="content" ref={setContainerElement}>
        <div className="background" ref={setBackgroundElement} />

        {channels.map((index) => (
          <Channel index={index} channelsCount={channels.length} key={index} />
        ))}

        {mouseSelection && <ChannelsSelection range={mouseSelection} />}

        {shiftDown && playbackCursorPosition !== null && mousePositionRef && !playback && (
          <ChannelsShiftSelection playbackCursorPosition={playbackCursorPosition} mousePositionRef={mousePositionRef} />
        )}

        {internalSelection && <ChannelsEditableSelection internalSelection={internalSelection} />}

        <PlaybackPosition render={(props) => <ChannelsLine className="playback" {...props} />} />

        <MousePosition render={(props) => <ChannelsLine className="mouse" {...props} />} />

        <ChannelsRewind />
      </div>
    </div>
  )
}
